<template>
    <!-- class="form-control" -->
    <div class="select-color-container" @click.stop="openSelectedColor()">
        <div class="selected-color">
            <div class="dd-color" style="width: fit-content;">
                <span :style="{
                    background: store.currentEditingProps.isDesignDst == true ? (store.allColors.value[modelValue].colorID !== -1
                        ? store.allColors.value[modelValue].color
                        : 'linear-gradient(to bottom, red 20%, orange 20% 40%, yellow 40% 60%, green 60% 80%, blue 80%)') : store.allColorsSVG.value[modelValue].color
                }">
                </span>

            </div>
            <span class="open-line-icon-span">
                <img class="icon-img" v-if="isOpen" style="transform:rotate(180deg);"
                    :src="store.baseIconsURL + '//Icons-OpenIconBlack.png'" />
                <img class="icon-img" style="transform:rotate(180deg);" v-if="!isOpen"
                    :src="store.baseIconsURL + '//Icons-CloseIconBlack.png'" />
            </span>
        </div>
        <div>
            <div class="colors-box" v-if="isOpen">
                <div v-for="(color, index) in getColors()" :key="index">
                    <div class="dd-color" @click.stop="chooseColor(color, $event)">
                        <span :style="{
                        background: store.currentEditingProps.isDesignDst == true ? (store.allColors.value[color.colorID].colorID!=-1?
                        store.allColors.value[color.colorID].color:
                       'linear-gradient(to bottom, red 20%, orange 20% 40%, yellow 40% 60%, green 60% 80%, blue 80%)') : store.allColorsSVG.value[color.colorID].color
                        }">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { designerStore } from "@/stores/designerStore";
// import { defineComponent } from '@vue/composition-api'

export default {
    setup() {
        const store = designerStore();
        return {
            store,
        };
    },
    props: ['modelValue'],
    emits: ['update:modelValue'],
    data() {
        return {
            colors: [],
            isOpen: false,
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside)
    },
    unmounted() {
        document.removeEventListener("click", this.handleClickOutside)
    },
    methods: {
        getColors() {
            if(this.store.currentEditingProps.isDesignDst == true) {
                return this.store.getAllColors();
            } else {
                return this.store.getAllSVGColors();
            }
        },
        handleClickOutside() { //event) {
            // console.log('click outside!');
            // if (customDiv.value && !customDiv.value.contains(event.target)) {
            this.isOpen = false;
            // }   
        },
        openSelectedColor() {
            this.isOpen = this.isOpen == true ? false : true;
            // document.getElementsByClassName('transform')[0].classList.add('transform-active');
        },
        // chooseColor(color, event) {
        //     console.log("color = ", color);
        //     console.log("e = ", event.target.value);
        //     this.isOpen = false;
        // }
        chooseColor(color, event) {
            console.log("color = ", color);
            console.log("e = ", event.target.value);

            // Emit the selected color
            this.$emit('update:modelValue', color.colorID);

            // Call the parent-provided method
            this.$emit('loadText', color.colorID); // Emit a custom event for loadText

            this.isOpen = false; // Close the dropdown
        },
    }
}
</script>
<style scoped>
/* .transform {
  -webkit-transition: all 2s ease;  
  -moz-transition: all 2s ease;  
  -o-transition: all 2s ease;  
  -ms-transition: all 2s ease;  
  transition: all 2s ease;
} */
.select-color-container {
    position: relative;
    padding: 0px;
}

.selected-color {
    display: flex;
    width: 100%;
    padding-left: 7px;
    position: relative;
}

.open-line-icon-span {
    cursor: pointer;
    right: 2px;
    height: 100%;
    top: 0;
    position: absolute;
    width: 18px;
    align-items: center;
    display: flex;
    justify-content: center;
}

.icon-img {
    width: 10px;
    height: 5px;
}

.dd-color {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
}

.dd-color>span {
    height: 18px;
        width: 18px;
    border-radius: 100px;
    display: inline-block;
}

/* .transform-active {
    display: grid;
} */
.colors-box {
    margin-top: 5px;
    position: absolute;
    z-index: 50;
    background-color: white;
    padding: 10px;
    gap: 7px;
    border-radius: 0.5em;
    border: 0.5px solid;

    display: grid;
    grid-template-columns: auto auto auto auto auto auto auto auto;
    width: fit-content;
}
</style>
